import { render } from "./Tabs.vue?vue&type=template&id=1d135b92&scoped=true&ts=true"
import script from "./Tabs.vue?vue&type=script&lang=ts"
export * from "./Tabs.vue?vue&type=script&lang=ts"

import "./Tabs.vue?vue&type=style&index=0&id=1d135b92&scoped=true&lang=css"

import exportComponent from "/home/runner/work/bakery-platform/bakery-platform/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d135b92"]])

export default __exports__